export default __webpack_public_path__ + "static/media/Terms-And-Condition.d397b4b0.jpg";